import { computed } from 'vue';
import { useSiteConfig } from './useSiteConfig';
import { categoryIconSizeToCss, normalizeCategoryIconSizeValue, resolveCategoryIconPadding, } from '../utils/categoryIconTheme';
export { resolveCategoryIconPadding } from '../utils/categoryIconTheme';
const DEFAULT_SETTINGS = {
    size: { value: 24, unit: 'px' },
    gap: { value: 12, unit: 'px' },
    padding: '8px',
};
export function useCategoryIconStyles() {
    const { siteConfig } = useSiteConfig();
    const settings = computed(() => {
        const themeIcons = siteConfig.value?.theme?.categoryIcons;
        return {
            size: normalizeCategoryIconSizeValue(themeIcons?.size, DEFAULT_SETTINGS.size),
            gap: normalizeCategoryIconSizeValue(themeIcons?.gap, DEFAULT_SETTINGS.gap),
            padding: resolveCategoryIconPadding(themeIcons?.padding, DEFAULT_SETTINGS.padding),
        };
    });
    const cssVars = computed(() => ({
        '--category-icon-size': categoryIconSizeToCss(settings.value.size),
        '--category-icon-gap': categoryIconSizeToCss(settings.value.gap),
        '--category-icon-padding': settings.value.padding,
    }));
    const wrapperStyle = computed(() => ({
        ...cssVars.value,
        gap: 'var(--category-icon-gap)',
    }));
    return {
        settings,
        cssVars,
        wrapperStyle,
        toCssLength: categoryIconSizeToCss,
    };
}
